export default __webpack_public_path__ + "static/media/Initiate's Gloves of the Exiled.99c0e220.jpg";